import CameraCheckCalendar from "../../components/Fleet/CameraCheck/CameraCheckCalendar";

const CameraCheckPage = () => {
  return (
    <>
      <CameraCheckCalendar />
    </>
  );
};

export default CameraCheckPage;
